var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230.33 105.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7e07d;}.cls-2{fill:#685d4a;}.cls-3{fill:#fbc726;}.cls-4{fill:#aba5ab;}.cls-5{fill:#e382b5;}.cls-6{fill:#89b85d;}.cls-7{fill:#fff;}.cls-8{fill:#77a546;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.18 29.37 198.45 52.28 217.54 43.71 217.06 35.8 197.18 29.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.12,38.41l-8.06-2.61.48,7.91,7.68-3.47A1,1,0,0,0,225.12,38.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201,48.29a4.31,4.31,0,0,0-2.86-3.68,4.31,4.31,0,0,0,2.44-4,4.43,4.43,0,0,0-2.7-3.65,4.44,4.44,0,0,0,2.28-3.92,4.24,4.24,0,0,0-2.92-3.69L186.25,30l-2.83,23.22,15-.89A4.29,4.29,0,0,0,201,48.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.67,
    y: 39.09,
    width: 5.96,
    height: 23.03,
    transform: "translate(-2.76 1.33) rotate(-3.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19,39.27l-8.46.47A5.89,5.89,0,0,0,5,46l.62,11.22a5.89,5.89,0,0,0,6.21,5.56l8.46-.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.99 38.94 26.26 61.93 42.01 61.06 39.02 38.17 24.99 38.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.82,5H46.56A13.77,13.77,0,0,0,32.9,20.49l8.59,68.36A13.76,13.76,0,0,0,55.15,100.9H169.23a13.76,13.76,0,0,0,13.66-12.05l8.59-68.36A13.77,13.77,0,0,0,177.82,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.68,54.64a25.11,25.11,0,0,1-50.16,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154,55.52a8.37,8.37,0,1,1-16.72.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.82,58.14a25.11,25.11,0,0,1-50.15,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.1,59a8.37,8.37,0,0,1-16.71.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M101.32,44.7l-6-.56.28-3.22a1,1,0,0,0-.9-1.06,1,1,0,0,0-1.06.89L93.36,44l-6.29-.59L87,39.18a1,1,0,0,0-1-1,1,1,0,0,0-1,1l.07,4-5-.47.26-2.51a1,1,0,0,0-.88-1.08,1,1,0,0,0-1.08.88l-.26,2.53-4.58-.43.75-3.44a1,1,0,0,0-1.92-.42l-.8,3.68-5.2-.49.44-3.59A1,1,0,0,0,66,36.76a1,1,0,0,0-1.1.85l-.45,3.65-6-.56.7-4.08a1,1,0,1,0-1.94-.33l-.73,4.23L51.48,40a1,1,0,1,0-.18,2l4.91.46-.76,4.42a1,1,0,0,0,.8,1.14h.16a1,1,0,0,0,1-.81l.79-4.58,6.09.57-.41,3.36a1,1,0,0,0,.85,1.09h.12a1,1,0,0,0,1-.86l.42-3.42,5,.47-1,4.44A1,1,0,0,0,71,49.47a.76.76,0,0,0,.21,0,1,1,0,0,0,1-.78l1-4.67,4.8.45-.27,2.63a1,1,0,0,0,.88,1.08h.1a1,1,0,0,0,1-.89L80,44.68l5.18.48.08,4.47a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1l-.07-4.24,6.08.57-.29,3.42a1,1,0,0,0,.89,1.07h.09a1,1,0,0,0,1-.9l.29-3.41,6,.56h.09a1,1,0,0,0,.09-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.82,5H46.56A13.77,13.77,0,0,0,32.9,20.49L34,28.91c12.51-.29,12.76-9.11,25.69-9.11,13.15,0,13.15,9.14,26.3,9.14s13.15-9.14,26.3-9.14,13.16,9.14,26.32,9.14,13.15-9.14,26.3-9.14c12.89,0,13.19,8.74,25.55,9.1l1.06-8.41A13.77,13.77,0,0,0,177.82,5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ba4460a80c88e365e211a027ee61ad0d.svg";
export { ForwardRef as ReactComponent };